import { Container, Section, ChangeContactForm } from 'components';

export default function ChangeContactPage() {
  return (
    <Container>
      <Section color="teal" title="Change contact">
        <ChangeContactForm />
      </Section>
    </Container>
  );
}
